import React from 'react';
import { Button, Image } from 'react-bootstrap';

import {
  slideEnvia,
  slidePagaServicio,
  slideRegarga,
  slidePagaComercio,
  slideRecibe
} from '../../../../../assets/images';
import classes from './SecondaryItem.module.css'

const SecondaryItem = props => {

  let mainImage = ({
    'slide-envia': slideEnvia,
    'slide-paga-servicio': slidePagaServicio,
    'slide-recarga': slideRegarga,
    'slide-paga-comercio': slidePagaComercio,
    'slide-recibe': slideRecibe
  })[props.image] || slideEnvia;

  let backgroundColor = ({
    'green': 'backgroundGreen',
    'yellow': 'backgroundYellow',
    'blue': 'backgroundBlue'
  })[props.background] || 'backgroundGreen';

  return (
    <div>
      <div className={`slide-mobile ${classes[backgroundColor]}`}>
        <div className={classes.itemMainContent}>
          <div>
            <h1 className={classes.titleItem}>{props.title}</h1>
            <h2 className="slide-subtitle title-mobile-ad mobile-text" >{props.subtitle}</h2>
          </div>

          <div>
            <Image
              className={classes.mainImage}
              src={mainImage}
              alt="enviar dinero"
            />
          </div>
          <div className={classes.mainText}>
            {props.children}
          </div>
          <div className={classes.contentButton}>
            <Button variant="button-round btn-wite" onClick={props.onClick}>{props.buttonText}</Button>
          </div>
        </div>
      </div>
      <div className={`slide-desktop ${classes[backgroundColor]}`}>
        <div className={classes.itemMainContentDesk}>
          <div className={`${classes.contentMidle} ${classes.contentCenter}`} >
            <img
              className="phone-envia"
              src={mainImage}
              alt="phone paga servicios"
            />
          </div>
          <div className={classes.mainTextContent}>
            <div>
              <h1 className="slide-title ">{props.title}</h1>
              <h2 className="slide-subtitle">{props.subtitle}</h2>
            </div>
            <div>
              {props.children}
            </div>
            <div className={classes.contentMidle}>
              <Button variant="button-round btn-wite" onClick={props.onClick}> &nbsp;&nbsp;&nbsp;&nbsp;Ver tutorial &nbsp;&nbsp;&nbsp;&nbsp;</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SecondaryItem;
